import { tera } from '@/helpers/ad/tera/tera.js';

export const ad = () => {
        // 광고스크립트
        tera.init();
};